export default function isCameraSupported(): boolean {
  return (
    navigator.mediaDevices !== undefined &&
    navigator.mediaDevices.getUserMedia !== undefined
  );
}
